import * as TipoObjeto from "../constantes/TipoObjeto.js";

export const UrlBase = (tipoObjeto) => {
    let urlBase = "";
    switch (tipoObjeto) {
      case TipoObjeto.CLUB:
        urlBase = "clubes";
        break;
      case TipoObjeto.PAIS:
        urlBase = "paises";
        break;
      case TipoObjeto.ORGANIZADOR_TORNEOS:
        urlBase = "torneos/organizadores";
        break;
      case TipoObjeto.PERSONA:
        urlBase = "personas";
        break;
      default:
    }
    return urlBase;
}

export const UrlBoletin = (tipoObjeto, idBoletin) => {
    let urlBase = "boletines_afa/" + idBoletin + "/parametros/";
    switch (tipoObjeto) {
      case TipoObjeto.CLUB:
        urlBase += "clubes";
        break;
      case TipoObjeto.PAIS:
        urlBase += "paises";
        break;
      case TipoObjeto.ORGANIZADOR_TORNEOS:
        urlBase += "organizadores_torneos";
        break;
      default:
        urlBase = "";
    }
    return urlBase;
}